var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex-column mt-3"},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.addBuildPhase}},[_c('span',[_vm._v("Add Build Phase")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }